import BannerSingleOfferTemplatLoader from "./BannerSingleOfferTemplatLoader";
import {
    bannerFetchInitData,
    bannerReadyToShowAD,
    onAdShowTemp
} from "../../api";

class BannerTemplatFixWebviewShowLoader extends BannerSingleOfferTemplatLoader{
    constructor(...arg){
        super(...arg)
    }

    addAdShowListener(cb){
        console.log('注册-adShow-事件监听', window.onAdShowTempData)
        if(window.onAdShowTempData){
            setTimeout(()=>{
                cb(window.onAdShowTempData)
            },0)

        }else{
            document.addEventListener('dowebviewshow', function (res) {
                console.log('接收到-dowebviewshow res: ', res.param)
                //cb(res)
            }, false)
        }
    }
}

//临时
//console.log('注册-dowebviewshow-事件监听')
onAdShowTemp((data) => {
    console.log('onAdShowTemp ============>', data)
    window.onAdShowTempData = data
})

export default BannerTemplatFixWebviewShowLoader